import { Component, Input } from '@angular/core';

@Component({
  selector: 'lms-ranking-list-row',
  templateUrl: './ranking-list-row.component.html'
})
export class RankingListRowComponent {
  @Input() item: any;
  public listOptions: any = {};
  public ranking: any = [];
  constructor() {}
  1;
}
